<script setup lang="ts">
import AdminUnitsView from "./AdminUnitsView.vue";
import { FormCorporate } from "@/domains/home/services/nir/forms/components/widgets/types";


const props = defineProps({
  data: {
    type: Array as () => FormCorporate[],
  }
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: FormCorporate[]): void
}>()

function getIdTypeLabel(idType: string): string {
  const labels: Record<string, string> = {
    'national_id': 'National ID',
    'passport': 'Passport',
    'driving_permit': 'Driving Permit',
    'refugee_id': 'Refugee ID',
    'voter_id': 'Voter ID'
  }
  return labels[idType] || idType
}

function formatDate(dateString: string): string {
  if (!dateString) return '-'
  const date = new Date(dateString)
  return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
}
</script>

<template>
  <div class="flex flex-col space-y-4">
    <div v-if="data && data.length > 0">
      <div
        v-for="(individual, index) in data"
        :key="index"
        class="border border-gray-200 rounded-lg p-4 bg-gray-50 mb-3"
      >
        <div class="flex items-center justify-between mb-4 pb-3 border-b border-gray-200">
          <h4 class="text-base font-semibold text-gray-800">
            <i class="fa-solid fa-user mr-2 text-primary"></i>
            Entity {{ data.length > 1 ? `#${index + 1}` : "" }}
          </h4>
        </div>

        <div class="grid grid-cols-2 gap-4">
          <!-- Full Name -->
          <div class="col-span-2">
            <label class="text-xs font-semibold text-gray-500 uppercase tracking-wide">Entity Name</label>
            <p class="text-sm text-gray-900 font-medium mt-1">
              {{ individual.name }}
            </p>
          </div>

          <!-- ID Type -->
          <div>
            <label class="text-xs font-semibold text-gray-500 uppercase tracking-wide">Registration Number</label>
            <p class="text-sm text-gray-900 mt-1">
              <i class="fa-solid fa-id-badge text-gray-400 mr-1"></i>
              {{ individual.registrationNumber }}
            </p>
          </div>

          <div>
            <label class="text-xs font-semibold text-gray-500 uppercase tracking-wide">Registration Date</label>
            <p class="text-sm text-gray-900 mt-1">
              <i class="fa-solid fa-calendar text-gray-400 mr-1"></i>
              {{ formatDate(individual.registrationDate) }}
            </p>
          </div>

          <!-- Email -->
          <div>
            <label class="text-xs font-semibold text-gray-500 uppercase tracking-wide">Email</label>
            <p class="text-sm text-gray-900 mt-1">
              <i class="fa-solid fa-envelope text-gray-400 mr-1"></i>
              {{ individual.email || '-' }}
            </p>
          </div>

          <!-- Phone -->
          <div>
            <label class="text-xs font-semibold text-gray-500 uppercase tracking-wide">Phone</label>
            <p class="text-sm text-gray-900 mt-1">
              <i class="fa-solid fa-phone text-gray-400 mr-1"></i>
              {{ individual.phone || '-' }}
            </p>
          </div>

          <!-- Address -->
          <div v-if="individual.address" class="col-span-2">
            <label class="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2 block">
              <i class="fa-solid fa-map-marker-alt text-gray-400 mr-1"></i>
              Address
            </label>
            <AdminUnitsView :modelValue="individual.address" :data="individual.address" />
          </div>
        </div>
      </div>
    </div>
    <div v-else class="text-center py-8 text-gray-500 text-sm">
      <i class="fa fa-user-slash text-3xl mb-2"></i>
      <p>No individuals information available</p>
    </div>
  </div>
</template>

<style scoped></style>
